import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { versionAPI } from "./api";

const initialState = {
  value: "",
  loading: false,
  loaded: false,
};

export const loadVersion = createAsyncThunk(
  "version/loadVersion",
  async (_, { rejectWithValue }) => {
    try {
      const result = await versionAPI.loadVersion();

      if (result.status === 200) {
        return result.data;
      }
    } catch (error) {
      return rejectWithValue("Version not found");
    }
  }
);

// This middleware is used to refresh the token when the user is loading
// version. It will check if the token is expired and refresh it if needed.

// Create the slice
const versionSlice = createSlice({
  name: "version",
  initialState: cloneDeep(initialState),
  extraReducers: (builder) => {
    builder
      // Load version
      .addCase(loadVersion.pending, (state, _action) => {
        state.loading = true;
        state.loaded = false;
      })
      .addCase(loadVersion.fulfilled, (state, action) => {
        state.value = action.payload;
        state.loading = false;
        state.loaded = true;
      })
      .addCase(loadVersion.rejected, (state, _action) => {
        state.value = "";
        state.loading = false;
        state.loaded = false;
      });
  },
});

export default versionSlice.reducer;
